import { ReactNode, useEffect, useState } from 'react';

import clsx from 'clsx';
import { createPortal } from 'react-dom';

import styles from './toast.module.scss';

export enum ToastType {
  REGULAR = 'regular',
  ERROR = 'error',
}

export interface ToastProps {
  children: ReactNode;
  type?: ToastType;
  displayTimeMs?: number;
}

export const Toast = ({ children, type = ToastType.REGULAR }: ToastProps) => {
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const getToastWrapper = () => {
    let wrapper = document.getElementById('toast-wrapper');

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.setAttribute('id', 'toast-wrapper');
      wrapper.setAttribute('data-testid', 'toast-wrapper');
      document.body.appendChild(wrapper);
    }

    return wrapper;
  };

  const classes = clsx(styles.toast, {
    [styles.error]: type === 'error',
  });
  return isBrowser
    ? createPortal(
        <div className={classes} data-testid="toast">
          {children}
        </div>,
        getToastWrapper(),
      )
    : null;
};
